<!--
 * @Author: yuqiuyu 18180464352@163.com
 * @Date: 2022-05-12 10:13:54
 * @LastEditors: yuqiuyu 18180464352@163.com
 * @LastEditTime: 2022-07-07 10:17:36
 * @FilePath: \vueproject-master\src\App.vue
 * @Description:
 *
 * Copyright (c) 2022 by 斯马特有限公司, All Rights Reserved.
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: false
    };
  },
  reload() {
    this.isRouterAlive = false;
    this.$nextTick(() => {
      this.isRouterAlive = true;
    });
  },
  beforeCreate() {
    var os = (function() {
      var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
    })();
    if (os.isAndroid || os.isPhone) {
      // 手机
      // window.location.href = "http://47.108.228.90:8005/phone/#/";
      // window.location.href = "http://m.vetpoder.com";
      // window.location.href = "http://10.2.10.1:8025/phone/#/";
    } else {
      // 电脑pb
    }
  }
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  touch-action: none;
  background: #fff;
  /* 解决 弹窗出现 表格 会收缩的问题 */
  /* padding-right: 0px !important; */
  /* overflow: hidden !important; */
}

:root body {
  position: absolute;
}

body {
  width: 100vw;
  overflow: hidden;
  height: 100%;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/App.vue